<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            tin cung cầu</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tên cửa hàng:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên cửa hàng" v-model="search.cTenCuaHang" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Số điện thoại:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập số điện thoại " v-model="search.cDienThoai" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Địa chỉ:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập địa chỉ " v-model="search.cDiaChi" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tài khoản ngân hàng:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tài khoản ngân hàng " v-model="search.cSoTaiKhoanNganHang" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Chọn trạng thái" v-model="search.nTinhTrang">
                  <el-option label="Tất cả" value="5"></el-option>
                  <el-option label="Hoạt động" value="2"></el-option>
                  <el-option label="Đã khóa" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="findUser"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- Bảng tài khoản -->
    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function w-100">
          <div class="d-flex justify-content-end">
            <!-- <el-button type="primary" outline native-type="submit" :loading="isLoading" @click="handleAdd">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm cửa hàng</span>
            </el-button> -->
            <!-- <el-button plain style="margin-right:30px" title="Đồng bộ" type="warning"
              @click="handleSyncData" v-loading.fullscreen.lock="isLoading"><i class="el-icon-refresh"></i>
            </el-button> -->
          </div>
        </div>

      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%"
            fit stripe highlight-current-row>
            <el-table-column prop="cTenCuaHang" label="Tên cửa hàng" width="200" header-align="center"></el-table-column>
            <el-table-column prop="cDienThoai" label="Số điện thoại" width="120" header-align="center"></el-table-column>
            <el-table-column prop="cDiaChi" label="Địa chỉ" min-width="250" header-align="center"></el-table-column>
            <el-table-column prop="cSoTaiKhoanNganHang" label="Tài khoản ngân hàng" width="200" header-align="center"></el-table-column>
            <el-table-column prop="cTenChuTaiKhoan" label="Chủ tài khoản" width="200" header-align="center"></el-table-column>
            <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="warning" v-if="scope.row.nTinhTrang == 1">Chưa xử lý</el-tag>
                <el-tag type="success" v-if="scope.row.nTinhTrang == 2">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0">Đã xóa</el-tag>
              </template>
            </el-table-column>

            <!-- Button hành động -->
            <!-- <el-table-column width="150" label="Hành động" align="center">
              <template #default="scope">
                <el-button :disabled="scope.row.nTinhTrang == 0"  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit"></i></el-button>
                <el-button :disabled="scope.row.nTinhTrang == 0"  type="danger"
                  @click="deleteAccount(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>


    <!-- Modal -->
    <el-dialog v-model="centerDialogVisible" class="modalTemp p-0" :show-close="false">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 slot="header" class="modal-title">{{ operation ? "Cập nhật thông tin cửa hàng" : "Thêm cửa hàng" }}</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
            @click="centerDialogVisible = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>

      <el-form :model="validateForm" :rules="rules" ref="validateFormRef" label-width="150px" class="demo-ruleForm"
        >
        <div class="row">
          <div class="col-sm">
            <el-form-item label="Tên cửa hàng" prop="cTenCuaHang">
              <el-input v-model="validateForm.cTenCuaHang" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="Điện thoại" prop="cDienThoai">
              <el-input v-model="validateForm.cDienThoai" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="Địa chỉ" prop="cDiaChi">
              <el-input v-model="validateForm.cDiaChi" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="Số tài khoản" prop="cSoTaiKhoanNganHang">
              <el-input v-model="validateForm.cSoTaiKhoanNganHang" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="Tên tài khoản" prop="cTenChuTaiKhoan">
              <el-input v-model="validateForm.cTenChuTaiKhoan" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="Ngân hàng">
              <el-select filterable placeholder="Chọn ngân hàng" v-model="validateForm.nMaNganHang" style="width: 50%;">
                <el-option v-for="item in bankList" :key="item.nMaNganHang" :label="item.cTenNganHang"
                  :value="item.nMaNganHang"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <template #footer>
        <div class="modal-footer">
          <div class="btn-group">
            <el-button v-if="!operation" type="primary" @click="saveAccount()" :loading="isLoading">Thêm</el-button>
            <el-button v-if="operation" type="primary" @click="saveAccount()" :loading="isLoading">Lưu</el-button>
            <el-button v-if="operation" outline type="danger" @click="closeForm">Thoát</el-button>
            <el-button v-if="!operation" outline type="danger" @click="closeForm1">Thoát</el-button>
          </div>
        </div>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { saveAs } from "file-saver";
import moment from "moment";
import { Bank, Shop } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      rules: {
        cTenCuaHang: [
          { required: true, message: "Bạn chưa nhập tên cửa hàng", trigger: "blur", },
        ],
        cDienThoai: [
          { required: true, message: "Bạn chưa nhập số điện thoại", trigger: "blur" },
        ],
        cDiaChi: [
          { required: true, message: "Bạn chưa nhập địa chỉ", trigger: "blur" },
        ],
      },
      bankList: [],
      isLoading: false,
      isSearchLoading: false,
      tableData: [],
      search: {
        cTenCuaHang: "",
        cDienThoai: "",
        cDiaChi: "",
        cSoTaiKhoanNganHang: "",
        nTinhTrang: "5"
      },
      pageRequest: { pageNum: 1, pageSize: 30 },
      operation: false,
      centerDialogVisible: true,
      validateForm: {
        nMaCuaHang: "",
        cTenCuaHang: "",
        cDienThoai: "",
        cDiaChi: "",
        cSoTaiKhoanNganHang: "",
        cTenChuTaiKhoan: "",
        nMaNganHang: ""
      },
      store: useStore()
    };
  },
  methods: {
    handleSyncData() {
      this.store.dispatch(Shop.syncShop).then(res => {
        if (res.code == 200) {
          ElMessage({ message: res.msg, type: "success" })
          this.handleSearch()
        } else {
          ElMessage({ message: res.msg, type: "error" })
          this.handleSearch()
        }
      })
    },
    handleAdd() {
      this.centerDialogVisible = true;
      this.operation = false;
      this.validateForm = {
        nMaCuaHang: "",
        cTenCuaHang: "",
        cDienThoai: "",
        cDiaChi: "",
        cSoTaiKhoanNganHang: "",
        cTenChuTaiKhoan: "",
        nMaNganHang: ""
      };
    },

    handleEdit(index, item) {
      this.centerDialogVisible = true
      this.operation = true
      this.validateForm = Object.assign({}, item);
    },

    handleSearch() {
      this.findUser();
    },

    closeForm() {
      this.$refs.validateFormRef.resetFields();
      this.centerDialogVisible = false;
    },
    closeForm1() {
      this.$refs.validateFormRef.resetFields();
      this.centerDialogVisible = false;
    },

    findUser(pageNum, pageSize) {
      this.isSearchLoading = true
      if (typeof pageNum == "number") this.pageRequest.pageNum = pageNum;
      else this.pageRequest.pageNum = 1;

      if (typeof pageSize == "number") this.pageRequest.pageSize = pageSize;
      else this.pageRequest.pageSize = 30;

      this.pageRequest.columnFilters = {
        cTenCuaHang: { value: this.search.cTenCuaHang },
        cDienThoai: { value: this.search.cDienThoai },
        cDiaChi: { value: this.search.cDiaChi },
        cSoTaiKhoanNganHang: { value: this.search.cSoTaiKhoanNganHang },
        nTinhTrang: { value: this.search.nTinhTrang },
      };

      this.store.dispatch(Shop.findPageShop, this.pageRequest).then((res) => {
        this.isSearchLoading = false
        if (res.code == 200 && res.data)
          this.tableData = res.data;
        else
          this.tableData = []
      });
    },

    saveAccount() {
      this.$refs.validateFormRef.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.validateForm);
          this.store.dispatch(Shop.saveShop, params).then((res) => {
            if (res.code == 200) {
              if (this.operation == false) {
                ElMessage({ message: "Thêm cửa hàng thành công!", type: "success", });
              } else {
                ElMessage({
                  message: "Cập nhật cửa hàng thành công!",
                  type: "success",
                });
              }
              this.$refs["validateFormRef"].resetFields();
              this.centerDialogVisible = false;
              this.findUser();
            } else {
              if (this.operation == false) {
                ElMessage({
                  message: "Thêm cửa hàng thất bại!",
                  type: "error",
                });
              } else {
                ElMessage({
                  message: "Cập nhật cửa hàng thất bại!",
                  type: "error",
                });
              }
            }
          });
        }
      });
    },

    deleteAccount(index, item) {
      this.$confirm("Bạn có muốn xóa cửa hàng này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          let params = { nMaCuaHang: item.nMaCuaHang };
          this.store.dispatch(Shop.deleteShopRecord, params).then((res) => {
            if (res.code == 200) {
              ElMessage({
                message: `Xóa thành công cửa hàng ${item.cTenCuaHang}`,
                type: "success",
              });
              this.findUser();
            } else {
              ElMessage({ message: `Xóa thất bại, ` + res.msg, type: "error" });
            }
          });
        })
        .catch(() => { });
    },

    //
    handleSizeChange(val) {
      this.findUser(this.pageRequest.pageNum, val);
    },
    handleCurrentChange(val) {
      this.findUser(val, this.pageRequest.pageSize);
    },

    getBankList() {
      this.store.dispatch(Bank.showBank).then((res) => {
        if (res.code == 200 && res.data)
          this.bankList = res.data
        else
          this.bankList = []
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }
  },
  mounted() {
    this.findUser()
    this.getBankList()
    this.centerDialogVisible = false
  },
};
</script>
<style lang="scss" scoped>
.tbl {
  height: calc(100vh - 255px);
}

.box-card {
  margin: 10px;
}
</style>
<style>
.modalTemp .modal-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.card-header {
  padding: 0px;
}

.font-details {
  font-size: 18px;
  font-weight: 500;
}
</style>
